export default "__VITE_ASSET__CluQ1Mwx__"